// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__vE8zz","spinner":"Spinner_spinner__i3Wdm"};